import React, {
  useCallback,
} from 'react'

import PropTypes from 'prop-types'
import classnames from 'classnames'

import { Button } from '@termly/react-components'

import Styles from './styles.scss'


export default function TextLink(props) {
  const {
    children,
    className,
    handleClick,
    'data-tid': dataTid,
    ...otherProps
  } = props

  const onClick = useCallback((e) => {
    if ( !handleClick ) {
      return
    }

    e.stopPropagation()

    handleClick()
  }, [handleClick])

  const onKeyUp = useCallback((e) => {
    if ( e.key !== 'Enter' ) {
      return
    }

    onClick(e)
  }, [onClick])

  const rootClassName = classnames(Styles.root, className)

  const Tag = ( handleClick ) ? 'span' : 'a'

  return (
    <Tag
      className={ rootClassName }
      data-tid={ dataTid }
      onClick={ onClick }
      onKeyUp={ onKeyUp }
      role="link"
      tabIndex={ 0 }
      { ...otherProps }
    >
      { children }
    </Tag>
  )
}

TextLink.propTypes = {
  children: PropTypes.node.isRequired,

  'data-tid': PropTypes.string,
  className: PropTypes.string,
  handleClick: Button.propTypes.handleClick,
  href: PropTypes.string,
}
